module.exports = __webpack_public_path__ + "img/hr-sand-rock-medium-03.75c2bcda.png";